<template>
  <div class="sync-page">
    <a-card>
      <div class="sync-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="sync-title">同步中心</div>
          <a-tabs v-model:activeKey="tabKey" style="margin-bottom: 16px;">
            <a-tab-pane key="up" tab="上游同步" />
            <a-tab-pane key="down" tab="同步到下游" />
          </a-tabs>
          <a-button type="primary" style="margin-bottom: 16px;">创建同步任务</a-button>
          <a-table :columns="columns" :data-source="[]" :pagination="false" size="middle" style="margin-top: 8px;">
            <template #emptyText>
              <div style="text-align:center;padding:32px 0;">
                <a-empty description="暂无数据" />
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

const tabKey = ref('up')

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id' },
  { title: '同步对象', dataIndex: 'target', key: 'target' },
  { title: '同步模式', dataIndex: 'mode', key: 'mode' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]
</script>

<style lang="less" scoped>
.sync-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
  .sync-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #f8fafb;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .sync-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 12px;
      }
    }
  }
}
</style> 